import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton, Menu, MenuItem, MenuTrigger, Text } from '@react-spectrum/s2';
import { Folder, Add as S2Add, SocialNetwork } from '../icons/s2';
import './AddDomainMenu.css';

export type CreatableDomainType = 'standard' | 'orchestrator';

interface AddDomainMenuProps {
  onOpenCreate: (domainType?: CreatableDomainType) => void;
  className?: string;
  'data-tour'?: string;
}

/** "+ Add" ActionButton opening a Spectrum Menu of domain types. */
export const AddDomainMenu: React.FC<AddDomainMenuProps> = ({
  onOpenCreate,
  className,
  'data-tour': dataTour,
}) => {
  const { t } = useTranslation();
  return (
    <MenuTrigger align="end">
      <ActionButton
        UNSAFE_className={`flameback-add-domain-btn ${className ?? ''}`.trim()}
        data-tour={dataTour} aria-label={t('components.addDomainMenu.addAria')}>
        <S2Add />
        <Text>{t('components.addDomainMenu.add')}</Text>
      </ActionButton>
      <Menu onAction={(key) => onOpenCreate(key as CreatableDomainType)}>
        <MenuItem id="standard" key="standard" textValue={t('components.addDomainMenu.standard')}>
          <Folder size="S" />
          <Text slot="label">{t('components.addDomainMenu.standard')}</Text>
          <Text slot="description">{t('components.addDomainMenu.standardDescription')}</Text>
        </MenuItem>
        <MenuItem id="orchestrator" key="orchestrator" textValue={t('components.addDomainMenu.orchestrator')}>
          <SocialNetwork size="S" />
          <Text slot="label">{t('components.addDomainMenu.orchestrator')}</Text>
          <Text slot="description">{t('components.addDomainMenu.orchestratorDescription')}</Text>
        </MenuItem>
      </Menu>
    </MenuTrigger>
  );
};
